// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox_checkbox__aKfQk {
    display: flex;
    align-items: center;
    -webkit-user-select: none;
            user-select: none;
}

.checkbox_checkboxWrapper__7w4Qk {
    display: flex;
    align-items: center;
}

.checkbox_checkboxInput__tEmHr {
    display: flex;
    align-items: center;
}

.checkbox_customCheckbox__rLe4Z {
    width: 20px;
    height: 20px;
    border: 2px solid #626465;
    border-radius: 4px;
    background-color: #fff;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}

.checkbox_checkboxIcon__pNQzK {
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
}

.checkbox_customCheckbox__rLe4Z.checkbox_checked__8qKVX {
    border: 2px solid #1976D2;
    background-color: #1976D2;
}

.checkbox_customCheckbox__rLe4Z.checkbox_checked__8qKVX .checkbox_checkboxIcon__pNQzK {
    opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/inputs/checkbox/checkbox.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd","sourcesContent":[".checkbox {\n    display: flex;\n    align-items: center;\n    user-select: none;\n}\n\n.checkboxWrapper {\n    display: flex;\n    align-items: center;\n}\n\n.checkboxInput {\n    display: flex;\n    align-items: center;\n}\n\n.customCheckbox {\n    width: 20px;\n    height: 20px;\n    border: 2px solid #626465;\n    border-radius: 4px;\n    background-color: #fff;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.checkboxIcon {\n    opacity: 0;\n    transition: opacity 0.3s ease-in-out;\n}\n\n.customCheckbox.checked {\n    border: 2px solid #1976D2;\n    background-color: #1976D2;\n}\n\n.customCheckbox.checked .checkboxIcon {\n    opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox": `checkbox_checkbox__aKfQk`,
	"checkboxWrapper": `checkbox_checkboxWrapper__7w4Qk`,
	"checkboxInput": `checkbox_checkboxInput__tEmHr`,
	"customCheckbox": `checkbox_customCheckbox__rLe4Z`,
	"checkboxIcon": `checkbox_checkboxIcon__pNQzK`,
	"checked": `checkbox_checked__8qKVX`
};
export default ___CSS_LOADER_EXPORT___;
